export { }
const jobs = [
    {
        title: "Software Engineer",
        company: "Bank of America",
        type: "infosys",
        start: "May 2023",
        end: "Present",
        description: [
            "Utilized in-house framework to create, test and deploy sites and widgets",
            "Created shell scripts to enhance basic authentication workflows by reducing the number of chrome tabs",
            "Coded and tested authentication flows for a secure and streamlined user experience",
            "Supported quarterly releases by coordinating w/ QA, services, and design team",
            "Wrote bash and nodejs scripts to enhance daily workflows for developers"
        ],
        tools: ["Node.js", "jQuery", "HTML", "CSS", "JavaScript", "Bash"]
    },
    {
        title: "Software Engineer",
        company: "CBRE",
        type: "infosys",
        start: "November 2022",
        end: "January 2023",
        description: [
            "Used various React concepts/ and tools to build and design a Smart Cleaning App for janitors",
            "Collaborated w/ different coworkers on Smart Cleaning App",
            "Connected Smart Cleaning App w/ remote sensors using REST API to efficiently assign cleaning tasks",
            "Tested Smart Cleaning App by assigning cleaning tasks to janitors",
            "Decoupled backend and UI code to streamline testing and design across teams",
        ],
        tools: ["React", "Node.js", "CSS", "HTML"]
    },
    {
        title: "Software Engineer",
        company: "Citi",
        type: "infosys",
        start: "April 2021",
        end: "August 2022",
        description: [
            "Developed and deployed shell scripts to automate SMTP operations",
            "Built report generation service verifying operational and UX integrity for releases",
            "Developed user dashboards in React and SpringBoot to display various customer metrics",
            "Refactored codebase to increase modularity and readability, adding documentation where needed",
            "Created, updated and tested REST API services to manage different web apps for GENESIS project"
        ],
        tools: ["Java", "SpringBoot", "Maven", "SQL", "Node.js", "ExpressJS", "React", "Angular", "CSS", "Bootstrap", "Bash"]
    },
    {
        title: "Software Engineer",
        company: "Infosys",
        type: "fulltime",
        start: "June 2020",
        description: [
            "Collaborated w/ various clients to build and enhance existing projects",
            "Worked on multiple projects using various tools and technologies",
            "Set up basic functionality for internal shopping app using SpringBoot",
            "Onboarded Infosys software development teams onto Citibank tech infrastructure"
        ],
        tools: [
            "Java",
            "SpringBoot",
            "Maven",
            "SQL",
            "Node.js",
            "ExpressJS",
            "TypeScript",
            "React",
            "Angular",
            "Bootstrap",
            "HTML",
            "CSS",
            "JavaScript",
            "Bash"
        ]

    },
    {
        title: "Software Engineer Intern",
        company: "Ixia",
        type: "internship",
        start: "June 2017",
        end: "August 2017",
        description: [
            "Modified tools used in software design processes to streamline operations",
            "Worked with QA testers to perform testing meeting various parameters",
            "Gathered customer feedback and worked to resolve specific concerns",
            "Documented technical specifications and project testing methods for future reference."
        ],
        tools: ["Java", "Bash"]
    },
]

export const internships = jobs.filter(e => e.type === "internship")
export const fulltime = jobs.filter(e => e.type === "fulltime")
export const infosys = jobs.filter(e => e.type === "infosys")